export enum CreateFlow {
  SELECT_TYPE = 'select-type',
  STANDARD = 'standard',
  DISTRO = 'lakehouse',
}

export enum StepId {
  CreateNetwork = 'create_network',
  CreateLakehouse = 'create_lakehouse',
  ChooseSource = 'choose_source',
  ConnectBigQuery = 'connect_bigquery',
  ConnectSnowflake = 'connect_snowflake',
  ConnectCloudera = 'connect_cloudera',
  ConnectDatabricks = 'connect_databricks',
  ConnectPostgres = 'connect_postgres',
  ConnectMySql = 'connect_mysql',
  ConnectS3 = 'connect_s3',
  SelectS3File = 'select_s3_file',
  SelectTable = 'select_table',
  SharingPermissions = 'sharing_permissions',
  ColumnSharingPermissions = 'column_sharing_permissions',
  RowSharingPermissions = 'row_sharing_permissions',
  AddNodes = 'add_nodes',
  Confirmation = 'confirmation',
  SelectUpdateColumns = 'select_update_columns',
  TableSettings = 'table_settings',
  SelectVendiaTables = 'select_vendia_tables',
  JoinVendiaTables = 'join_vendia_tables',
  SelectConnection = 'select_connection',
  ReviewMultipleTables = 'review_multiple_tables',
  UploadFile = 'upload_file',
  UploadingStatus = 'uploading_status',
  ConfigureCsv = 'configure_csv',
}

export const DEFAULT_REGION = 'us-west-2'
